import { render, staticRenderFns } from "./benefitsCard.vue?vue&type=template&id=4a318305&scoped=true"
import script from "./benefitsCard.vue?vue&type=script&lang=js"
export * from "./benefitsCard.vue?vue&type=script&lang=js"
import style0 from "./benefitsCard.vue?vue&type=style&index=0&id=4a318305&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a318305",
  null
  
)

export default component.exports